import React from 'react'

import FormColumnsWrap from './styles'

const FormColumns: React.FC = (props): React.ReactElement => (
  <FormColumnsWrap>{props.children}</FormColumnsWrap>
)

export default FormColumns
